import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class QualityProxy {
  static GetAllQuality = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/quality",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllQualityMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/quality/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleQuality = (qualityId, callback) => {
    let params = {
      id: qualityId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/quality",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckQualityAvailable = (quality, callback) => {
    let params = {
      quality: quality,
    };

    restAPICall(
      Constants.MANAGER_URL + "/quality/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddQuality = (quality, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/quality",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(quality),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateQuality = (quality, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/quality",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(quality),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteQuality = (quality, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/quality",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(quality),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
